import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.css';

import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';
import ChiSiamo from './pages/ChiSiamo';
import Home from './pages/Home';
import { Route, Switch, Redirect } from 'react-router-dom'
import BagnoPage from './pages/BagnoPage';
import CucinaPage from './pages/CucinaPage';
import PreventivoPage from './pages/PreventivoPage';
import PortfolioPage from './pages/PortfolioPage';
import ListaPreventiviPage from './pages/ListaPreventiviPage';
import { ToastProvider } from './contexts/ToastContext';
import ReactGA from "react-ga4";
//import usePaginaTracking from './hook/usePaginaTracking';
const TRACKING_ID = "G-YGQX6HMYR5"; // Sostituisci con il tuo ID di monitoraggio
ReactGA.initialize(TRACKING_ID);

function App() {
  // Traccia la visualizzazione della pagina corrente
  ReactGA.send("pageview App");
 //usePaginaTracking()
  return (
    <ToastProvider>
      <BrowserRouter>
        <Switch>
          <Route path='/home' component={Home} />
          <Route path='/bagno' component={BagnoPage} />
          <Route path='/cucina' component={CucinaPage} />
          <Route path='/chisiamo' component={ChiSiamo} />
          <Route path='/preventivo' component={PreventivoPage} />
          <Route path='/portfolio' component={PortfolioPage} />

        {/* TODO PRVATE ROUTEs */}
          <Route path='/admin' component={ListaPreventiviPage} />

          <Route path='/'>
            <Redirect to='/home' />
          </Route>
        </Switch>

      </BrowserRouter>
    </ToastProvider>
  );
}
export default App;
